import type { Step } from '@de/types/types';

export function readStepMonetizationChannel(step?: Step): string | undefined {
  const value = step?.monetizationChannel;
  return typeof value === 'string' && value.trim() ? value.trim() : undefined;
}
